module.exports = __webpack_public_path__ + "img/Meldekopf.2b881e9e.svg";